import { render } from "./RidSddBancheInsoluti.vue?vue&type=template&id=370391f6&scoped=true"
import script from "./RidSddBancheInsoluti.vue?vue&type=script&lang=js"
export * from "./RidSddBancheInsoluti.vue?vue&type=script&lang=js"

import "./rid-sdd-banche-comune.css?vue&type=style&index=0&id=370391f6&scoped=true&lang=css"
import "./RidSddBancheInsoluti.vue?vue&type=style&index=1&id=370391f6&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370391f6"]])

export default __exports__